import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 20px;
`;

export const HistogramChartWrapper = styled.div<{ addExtraPadding?: boolean }>`
  height: ${({ addExtraPadding }) => (addExtraPadding ? '220px' : '239px')};
  margin-bottom: ${({ addExtraPadding }) => (addExtraPadding ? '40px' : '21px')};
`;

export const LineChartWrapper = styled.div<{ addExtraPadding?: boolean }>`
  height: 350px;
  margin-bottom: 40px;
`;

export const Heading = styled.h2`
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  padding-bottom: 20px;
`;

export const TableWrapper = styled.div<{ selectedIndex?: number }>`
  width: fit-content;

  table
    tr:nth-child(
      ${({ selectedIndex }) => (selectedIndex !== undefined && selectedIndex !== null ? selectedIndex + 1 : null)}
    )
    td {
    background-color: ${({ theme }) => theme.colorPalette.turquoise.background};
  }
`;

export const TableArea = styled.div`
  max-height: 500px;
  width: 100%;

  tr.row-selected td {
    background-color: ${({ theme }) => theme.colorPalette.white};
  }
`;

export const TableTitle = styled.div`
  font-weight: ${({ theme }) => theme.fontWeightPalette.medium};
  padding-bottom: 10px;
`;

export const TableDescription = styled.div`
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  padding-bottom: 15px;
`;

export const Table = styled.div`
  max-height: 500px;
`;
